import { API_BASE } from '../../../lib/api-base';

/**
 * Sends a multipart/form-data request with auth header wiring.
 * callEndpoint does not support FormData, so raw fetch is used here intentionally.
 */
export async function multipartFetch(
  path: string,
  method: string,
  formData: FormData,
  token: string | null | undefined,
): Promise<Response> {
  // eslint-disable-next-line no-restricted-globals -- multipart upload: callEndpoint does not support FormData
  return fetch(`${API_BASE}${path}`, {
    method,
    body: formData,
    credentials: 'same-origin',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
}
